import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { AuthService } from '../../shared/services/auth/auth.service';
import { ErrorService } from '../../shared/services/error/error.service';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';

import { UserModel } from 'src/app/shared/models/auth/user.model';
import { environment } from 'src/environments/environment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
// import { parameterProviderFactory } from 'src/app/app.module';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  public usuariosGuardados: string[];
  public show: boolean = false;
  public loginForm: FormGroup;
  public errorMessage: any;
  private unsubscribe: Subscription[] = [];
  // SC INTEGRA-130 Variable identifica si el usuario invitado esta activo.
  public invitado: boolean = false;
  public registro: boolean = false;
  private usuario : UserModel;
  constructor(
    public authService: AuthService,
    private fb: FormBuilder,
    public router: Router,
    public toastr: ToastrService,
    private modalService: NgbModal,
    private errorService: ErrorService
  ) {
    // SC INTEGRA-130 inicializacion y definicion de validacion para los campos del formulario de loguin.
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.maxLength(100)]],
      password: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(16)]],
      recordarme: [true]
    });

  }

  ngOnInit() {
    
  }

  showPassword() {
    this.show = !this.show;
  }

  // SC INTEGRA-130 funcion logion de usuario, redirige al home.
  login() {

    const { email, password } = this.loginForm.value;
    console.log(this.loginForm.value);

    const loginSub = this.authService.login(email, password)
      .subscribe(resp => {
        console.log(resp);
        if (resp.id! > 0) {
          this.authService.setAuthFromSessionStorage(resp);
          this.router.navigateByUrl('/home');
        } else {
          this.toastr.error(`${resp.error.message}`);
        }

      });
    this.unsubscribe.push(loginSub);

  }


  //MV CATWEB-322 Funcion para agregar usuario a usuariosGuardados si selecciona Recordarme y setear usuariosGuardados en localStorage
  private recordarUsuario(usuario: string) {
    if (this.loginForm.get('recordarme').value && !this.usuariosGuardados.includes(usuario)) {
      this.usuariosGuardados.push(usuario);
      localStorage.setItem('usuarios', JSON.stringify(this.usuariosGuardados));
    }
  }

  //MV CATWEB-322 Funcion para cargar los usuarios guardados en localStorage y almacenarlos en usuariosGuardados. 
  private cargarUsuariosRecordados() {
    if (localStorage.getItem('usuarios') !== null) {
      this.usuariosGuardados = JSON.parse(localStorage.getItem('usuarios'));
    } else {
      this.usuariosGuardados = [];
    }
  }
}
